import {
   HealthcareProviderAppointmentCancellationPatientNotificationConfigurationQuery,
   HealthcareProviderNotificationConfiguration,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationAppointmentCancellationToggleLoaderRenderProps = {
   healthcareProviderNotificationConfiguration: HealthcareProviderNotificationConfiguration;
};

type PatientPhoneNotificationAppointmentCancellationToggleLoaderProps = {
   readonly children: (
      renderProps: PatientPhoneNotificationAppointmentCancellationToggleLoaderRenderProps
   ) => JSX.Element;
};

export const PatientPhoneNotificationAppointmentCancellationToggleLoader = (
   props: PatientPhoneNotificationAppointmentCancellationToggleLoaderProps
): JSX.Element | null => {
   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderAppointmentCancellationPatientNotificationConfigurationQuery();
   });

   if (
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      healthcareProviderNotificationConfiguration: healthcareProviderNotificationConfiguration,
   });
};
